/* eslint-disable react/display-name */

import React, { Suspense, lazy } from 'react';

import { Card, Col, Skeleton, Spin } from 'antd';
import PropTypes from 'prop-types';

export default function Loader(dynamicComponent, customLoader = undefined) {
	const LazyComponent = lazy(dynamicComponent);

	return ({ ...props }) => (
		<Suspense
			fallback={
				customLoader !== undefined ? (
					customLoader
				) : (
					<Spin
						style={{
							position: 'absolute',
							top: '45%',
							left: '50%',
						}}
						size="large"
					/>
				)
			}
		>
			<LazyComponent {...props} />
		</Suspense>
	);
}

export function LoaderQuiet(dynamicComponent) {
	return Loader(dynamicComponent, null);
}

CardLoader.propTypes = {
	span: PropTypes.string.isRequired,
};

export function CardLoader({ span }) {
	return (
		<Col span={span}>
			<Card loading={true}></Card>
		</Col>
	);
}

export function SkeletonLoader() {
	return <Skeleton active></Skeleton>;
}
